import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { Tabs, Tab } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';

const LocationSearchTabs = (_param)=> {
    var { className , labels , tabIndex , onChange , listContent , isMobile , mapContent , showTabs =false , tabsRef  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "tabIndex",
        "onChange",
        "listContent",
        "isMobile",
        "mapContent",
        "showTabs",
        "tabsRef"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        ref: tabsRef,
        className: classnames('location-search-tabs', className)
    }), /*#__PURE__*/ React__default.createElement(Tabs, {
        activeTabIndex: tabIndex,
        onChange: onChange
    }, /*#__PURE__*/ React__default.createElement(Tab, {
        className: classnames('location-search-tabs__tab', {
            'location-search-tabs__tab--hidden': !showTabs
        }),
        label: /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Icon, {
            className: "location-search-tabs__tab-icon",
            name: "list"
        }), /*#__PURE__*/ React__default.createElement("span", {
            className: "location-search-tabs__tab-label"
        }, labels.listTab))
    }), /*#__PURE__*/ React__default.createElement(Tab, {
        className: classnames('location-search-tabs__tab', {
            'location-search-tabs__tab--hidden': !showTabs
        }),
        label: /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Icon, {
            className: "location-search-tabs__tab-icon",
            name: "location"
        }), /*#__PURE__*/ React__default.createElement("span", {
            className: "location-search-tabs__tab-label"
        }, labels.mapTab))
    })), /*#__PURE__*/ React__default.createElement("div", {
        className: "location-search-tabs__content"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: classnames('location-search-tabs__content-item', 'location-search-tabs__content-item-list', {
            'location-search-tabs__content-item--active': tabIndex === 0
        })
    }, isMobile && tabIndex !== 0 ? null : listContent), /*#__PURE__*/ React__default.createElement("div", {
        className: classnames('location-search-tabs__content-item', 'location-search-tabs__content-item-map', {
            'location-search-tabs__content-item--active': tabIndex === 1
        })
    }, isMobile && tabIndex !== 1 ? null : mapContent)));
};
var LocationSearchTabs$1 = LocationSearchTabs;

export { LocationSearchTabs$1 as default };
//# sourceMappingURL=LocationSearchTabs.js.map
